import React, { useEffect, useMemo } from 'react';
import ShowRecordsSection from '../../components/investigation/show/single/show_records_section';
import { filterRecordsFromSection } from '../../utils';
import { ISurvey } from '../../constants/types';
import Loader from '../../components/Loader';
import { getSubmissionPatientService } from '../../services';
import { useDispatch, useSelector } from 'react-redux';
import { get, isNumber } from 'lodash';
import { MatrixForm } from './patient/Forms/Matrix';
import { updateSubmissionPatientAction, fetchSubmissionsPatientInvestigationAction } from '../../redux/actions/submissionsPatientActions';
import { useHistory } from 'react-router-dom';
import { HOSPITAL_PATIENT } from '../../routes/urls';

interface ShowSubmissionPatientProps {
    currentSurvey:ISurvey,
    forceEdit:boolean,
    printMode?:boolean,
    submission?:any,
    idSubmission?:number,
    callBackEditSubmission?: (idSubmission:number, uuidSection:string, submission:any) => void,
    onPrintSubmission?: () => void,
}

const ShowSingleSubmissionPatient: React.FC<ShowSubmissionPatientProps> = ({ currentSurvey, forceEdit, printMode, submission, idSubmission, callBackEditSubmission, onPrintSubmission }) => {
    const uuidInvestigation = useSelector((state:any) => state.investigations.currentInvestigation.uuid);
    const patientsSubmissions = useSelector((state:any) => state.patientsSubmissions.data);
    
    const [submisionLocal, setSubmissionLocal] = React.useState<any>(null);
    const [loading, setLoading] = React.useState(isNumber(idSubmission));
    
    const submissionCached = useMemo(() => {
        if(submission){
            return submission;
        }
        return submisionLocal;
    }, [submission, submisionLocal]);


    const allSubmissions = useMemo(() => {
        if (!submissionCached?.uuidPatient || !patientsSubmissions?.[submissionCached.uuidPatient]) {
            return [];
        }
        
        const patientData = patientsSubmissions[submissionCached.uuidPatient];
        const surveyData = patientData[currentSurvey.uuid];
        
        if (!surveyData?.submissions) {
            return [];
        }
        
        return surveyData.submissions;
    }, [submissionCached?.uuidPatient, patientsSubmissions, currentSurvey.uuid]);

    const history = useHistory();
    const dispatch = useDispatch();


    console.log("currentSurvey beginning", currentSurvey);
    console.log("submission beginning", submission);
    console.log("submissionCached beginning", submissionCached);
    console.log("allSubmissions beginning", allSubmissions);
    
    useEffect(() => {
        async function getSubmission() {
            setLoading(true);
            const sub = await getSubmissionPatientService(uuidInvestigation, idSubmission, false);
            setSubmissionLocal(sub.submission);
            setLoading(false);
        }
        if(idSubmission && !submission){
            getSubmission();   
        }
        else{
            setLoading(false);
        }    
    }, [idSubmission, submission]);
    
    // Fetch all submissions for the patient if not already loaded
    useEffect(() => {
        if (submissionCached?.uuidPatient && !patientsSubmissions?.[submissionCached.uuidPatient]) {
            dispatch(fetchSubmissionsPatientInvestigationAction(uuidInvestigation, submissionCached.uuidPatient));
        }
    }, [submissionCached?.uuidPatient, uuidInvestigation, dispatch, patientsSubmissions]);


    if(loading){
        return <Loader />
    }

    console.log(currentSurvey);
    console.log(submission);


    if (currentSurvey.name === "MATRIX FORM") {
        console.log("submissionCached:", submissionCached);
        console.log("submissionCached.surveyRecords:", submissionCached?.surveyRecords);
        console.log("allSubmissions for MatrixForm:", allSubmissions);

        return <MatrixForm survey={currentSurvey} 
            submissions={allSubmissions}
            isVisualizingMode={true}
            callbackSurveyCompleted={
                (values: any, submissionId?: number) => {
                    console.log("currentSurvey", currentSurvey);
                    console.log("submission", submission);

                    console.log("postObj in ShowSingleSubmissionPatient", { uuidSurvey: currentSurvey.uuid, uuid_patient: submissionCached?.uuidPatient, id: idSubmission, surveyRecords: values },
                        uuidInvestigation,
                        submissionCached?.uuidPatient,
                        currentSurvey.uuid,
                        currentSurvey.name,
                        submissionId);

                    dispatch(updateSubmissionPatientAction(
                        { uuidSurvey: currentSurvey.uuid, uuid_patient: submissionCached?.uuidPatient, id: idSubmission, surveyRecords: values },
                        uuidInvestigation,
                        submissionCached?.uuidPatient,
                        currentSurvey.uuid,
                        currentSurvey.name,
                        submissionId
                    ));

                    
                    //console.log("Callback called with values:", values);
                // Call the edit submission callback with the updated data
                    // if (callBackEditSubmission && idSubmission) {
                    //     console.log("About to call callBackEditSubmission");
                    //     const updatedSubmission = {
                    //         ...submissionCached,
                    //         surveyRecords: values,
                    //         updatedAt: new Date().toISOString()
                    //     };
                    //     callBackEditSubmission(idSubmission, currentSurvey.uuid, updatedSubmission);
                    // }

                    // if (submissionCached?.uuidPatient) {
                    //     const patientUrl = HOSPITAL_PATIENT.replace(':uuidPatient', submissionCached.uuidPatient);
                    //     history.push(patientUrl);
                    // }

                    //window.location.reload();
            }
        
        }  />
    }


    return <ShowSingleSubmissionPatientView currentSurvey={currentSurvey} forceEdit={forceEdit} printMode={printMode} submission={submissionCached} 
                callBackEditSubmission={(idSubmission:number, uuidSection:string, submission:any) => callBackEditSubmission!(idSubmission, uuidSection, submission)}
                onPrintSubmission={onPrintSubmission}  />
};
export const ShowSingleSubmissionPatientView: React.FC<ShowSubmissionPatientProps> = ({ currentSurvey, forceEdit, printMode, callBackEditSubmission, submission, onPrintSubmission }) => {

    const recordsSection = Object.values(currentSurvey!.sections).sort((a:any,b:any) => a.order - b.order).map((section:any) => {
   
        const recordsSection = filterRecordsFromSection(submission, section.uuid);

        return(
            <ShowRecordsSection forceEdit={forceEdit} printMode={printMode}
                callBackEditSubmission={(idSubmission:number, uuidSection:string) => {
                    callBackEditSubmission!(idSubmission, uuidSection, submission)
                }} 
                records={recordsSection} section={section} uuidResearcher = {submission.uuidResearcher ? submission.uuidResearcher : submission.researcher.uuid}
                idSubmission = {submission.id}
                updatedAt={submission.updatedAt}
                onPrintSubmission={onPrintSubmission}/>
        )
    });
    return (
        <>
            {recordsSection}
        </>
    );
};

export default ShowSingleSubmissionPatient;
